import { render } from "./DecorationSetPicker.vue?vue&type=template&id=5f513b72&scoped=true"
import script from "./DecorationSetPicker.vue?vue&type=script&lang=js"
export * from "./DecorationSetPicker.vue?vue&type=script&lang=js"

import "./DecorationSetPicker.vue?vue&type=style&index=0&id=5f513b72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f513b72"]])

export default __exports__